export const menuData = [
  {
    id: 'kebab-bulka',
    name: 'Kebab w Bułce',
    items: [
      { name: 'Standard', description: '200g mięsa', price: '29 zł' },
      { name: 'Samo mięso', description: '300g', price: '34 zł' },
      { name: 'Mega', description: '300g mięsa', price: '36 zł' },
      { name: 'Grecki', description: 'oliwki + feta | 200g mięsa', price: '33 zł' },
      { name: 'Frytokebab', description: '200g mięsa', price: '32 zł' },
      { name: 'Drwala', description: 'podwójna bułka | 250g mięsa', price: '40 zł' },
      { name: 'Na talerzu', description: '250g mięsa', price: '36 zł' },
      { name: 'Falafel', description: '', price: '29 zł' },
      { name: 'Wegetariański', description: '', price: '23 zł' },
      { name: 'Wulkan', description: 'ostry | 200g mięsa', price: '32 zł' },
      { name: 'Gemüse', description: '200g mięsa', price: '33 zł' },
    ],
  },
  {
    id: 'lawasz',
    name: 'Lawasz (Tortilla)',
    items: [
      { name: 'Standard', description: '200g mięsa', price: '29 zł' },
      { name: 'XL', description: '300g mięsa', price: '40 zł' },
      { name: 'Samo mięso', description: '300g', price: '34 zł' },
      { name: 'Grecki', description: 'feta + oliwki | 200g mięsa', price: '33 zł' },
      { name: 'Grecki XL', description: 'feta + oliwki | 300g mięsa', price: '42 zł' },
    ],
  },
  {
    id: 'pita',
    name: 'Pita Turecka',
    items: [
      { name: 'Mała', description: '150g mięsa', price: '23 zł' },
      { name: 'Średnia', description: '200g mięsa', price: '29 zł' },
      { name: 'Megapita', description: '300g mięsa', price: '40 zł' },
      { name: 'Z serem', description: '200g mięsa', price: '31 zł' },
      { name: 'Megapita z serem', description: '300g mięsa', price: '42 zł' },
      { name: 'Z frytkami', description: 'bez surówki | 200g mięsa', price: '31 zł' },
      { name: 'Megapita z frytkami', description: 'bez surówki | 300g mięsa', price: '42 zł' },
    ],
  },
  {
    id: 'kebab-box',
    name: 'Kebab Box',
    items: [
      {
        name: 'Mięso/polędwiczki + frytki + surówka + sos',
        description: 'M (3 polędwiczki) | L (4 polędwiczki) | 160g mięsa | 220g mięsa',
        price: '28 zł / 34 zł',
      },
      {
        name: 'Mięso/polędwiczki + surówka + sos',
        description: 'M (3 polędwiczki) | L (4 polędwiczki) | 160g mięsa | 220g mięsa',
        price: '28 zł / 34 zł',
      },
      {
        name: 'Mięso/polędwiczki + frytki + sos',
        description: 'M (3 polędwiczki) | L (4 polędwiczki) | 160g mięsa | 220g mięsa',
        price: '29 zł / 35 zł',
      },
      {
        name: 'Samo mięso kebab + sos',
        description: 'M (3 polędwiczki) | L (4 polędwiczki) | 250g mięsa | 300g mięsa',
        price: '30 zł / 35 zł',
      },
    ],
  },
  {
    id: 'kapsalon',
    name: 'Kapsalon',
    items: [
      {
        name: 'Standard',
        description: '350g: mięso 160g + frytki + ser + sos',
        price: '29 zł',
      },
      {
        name: 'Mega',
        description: '450g: mięso 220g + frytki + ser + sos',
        price: '33 zł',
      },
    ],
  },
  {
    id: 'kanapki',
    name: 'Kanapki',
    items: [
      {
        name: 'Fresher',
        description: '2 polędwiczki + sałata + pomidor + ogórek',
        price: '22 zł',
      },
      {
        name: 'Striper',
        description: '4 polędwiczki + zestaw surówek + sos, w tortilli',
        price: '33 zł',
      },
      {
        name: 'Kebab z polędwiczkami',
        description: '4 polędwiczki + zestaw surówek + sos, w bułce',
        price: '33 zł',
      },
      {
        name: 'Frytokebab z polędwiczkami',
        description: 'w bułce',
        price: '34 zł',
      },
      { name: 'Pita z polędwiczkami', description: '', price: '33 zł' },
    ],
  },
  {
    id: 'zestawy',
    name: 'Zestawy i Menu dla Dzieci',
    items: [
      { name: 'Zestaw', description: '6 polędwiczek + małe frytki', price: '33 zł' },
      { name: 'Dla dzieci', description: '2 polędwiczki + małe frytki', price: '14 zł' },
    ],
  },
  {
    id: 'dodatki',
    name: 'Dodatki',
    items: [
      { name: '2 polędwiczki', description: '', price: '12 zł' },
      { name: 'Surówka', description: '100g', price: '7 zł' },
      { name: 'Frytki małe', description: '100g', price: '8 zł' },
      { name: 'Frytki duże', description: '150g', price: '9 zł' },
      { name: 'Porcja mięsa', description: '120g', price: '12 zł' },
      {
        name: 'Sos',
        description:
          '80ml | łagodny, ostry, mieszany, bardzo ostry, kiler, BBQ, meksykański, słodkie chilli, ketchup, 1000 wysp, czosnkowy',
        price: '3 zł',
      },
    ],
  },
  {
    id: 'napoje',
    name: 'Napoje',
    items: [
      { name: 'Burn', description: '0,25L', price: '10 zł' },
      { name: 'Cappy', description: '0,33L', price: '8 zł' },
      { name: 'Sprite, Fanta', description: '0,5L', price: '10 zł' },
      { name: 'Fuzetea', description: '0,5L', price: '10 zł' },
      { name: 'Kropla Beskidu', description: '0,5L', price: '6 zł' },
      { name: 'Coca Cola', description: '0,5L', price: '10 zł' },
      { name: 'Desperados', description: '', price: '13 zł' },
      { name: 'Lech, Tyskie, Perła', description: '', price: '12 zł' },
      { name: 'Kawa', description: 'od', price: '8 zł' },
      { name: 'Herbata', description: '', price: '8 zł' },
    ],
  },
];
